import { ErrorView, LoadingView } from "@fabricapp-ca/fabricapp-shared-ui";
import React from "react";
import { useHistory } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { firebaseVerifyEmail, resetToInitial } from "../Auth/FirebaseSlice";
import LoginLayout from "../Auth/LoginLayout";
import { SignInButton } from "../Auth/SignInButton";

export const EmailVerified = (props: any) => {
  const { basePath } = props;
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { currentUserInfo, error, authStatus } = useAppSelector(
    (state) => state.auth.firebaseAuth,
  );
  const [isLoading, setIsLoading] = React.useState(false);
  const [hasError, setHasError] = React.useState(false);

  // If user is already logged-in, re-direct them to the setup-profile
  React.useEffect(() => {
    if (currentUserInfo) {
      history.push("/setup-profile");
    } else {
      // uses the window.location.href to extract verification params
      dispatch(firebaseVerifyEmail());
    }
  }, [currentUserInfo, dispatch, history]);

  React.useEffect(() => {
    switch (authStatus) {
      case "VERIFY_LOADING":
        setIsLoading(true);
        break;
      case "VERIFY_DONE":
        setIsLoading(false);
        history.push(`${basePath}/setup-profile`);
        break;
      case "VERIFY_ERROR":
        setIsLoading(false);
        setHasError(true);
        break;
      default:
        break;
    }
  }, [authStatus, basePath, history]);

  if (isLoading) {
    return (
      <LoginLayout>
        <LoadingView />
      </LoginLayout>
    );
  }

  if (hasError && error) {
    return (
      <LoginLayout>
        <ErrorView message={error} />
        <SignInButton
          btnText={"Signup using another email"}
          onClick={() => {
            dispatch(resetToInitial());
            history.push(`${basePath}`);
          }}
        />
      </LoginLayout>
    );
  }

  return (
    <LoginLayout>
      <div className={"flex flex-col items-center justify-center"}>
        <div className={"mt-3 text-2xl font-medium text-default"}>
          Email Link Verified
        </div>
        <div className={"w-24 h-24 my-4"}>
          <LoadingView />
        </div>
        <div className={"text-default text-center"}>
          Loading account information ...
        </div>
      </div>
    </LoginLayout>
  );
};
